module.exports = __webpack_public_path__ + "img/chucheshenqing.c15f0313.png";